import { FC } from "react";

import IAQTabTemplate from "../Template";

type FieldErrors = { co2?: string; hcho?: string; tvoc?: string; pm25?: string; pm10?: string };

type PropTypes = {
  co2: number;
  hcho: number;
  tvoc: number;
  pm25: number;
  pm10: number;
  errors?: FieldErrors;
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ShortTermLimit: FC<PropTypes> = ({ co2, hcho, tvoc, pm25, pm10, errors, handleFieldChange }) => {
  return (
    <IAQTabTemplate
      infoDescription="Short-term Exposure Limit (ST): Maximum acceptable rolling average over a short window. Alert triggers when the rolling average over the specified period exceeds this value. Averaging period is fixed per DM-HSD-GU119."
      handleFieldChange={handleFieldChange}
      gasFields={[
        {
          label: "CO₂",
          unit: "ppm",
          hint: "Def: 700 ppm above outdoor / rolling avg N/A",
          value: co2,
          name: "shortTermLimit.co2",
          error: errors?.co2,
        },
        {
          label: "HCHO",
          unit: "ppm",
          hint: "Def: 0.08 ppm / 30-min rolling avg",
          value: hcho,
          name: "shortTermLimit.hcho",
          error: errors?.hcho,
        },
        {
          label: "TVOC",
          unit: "ppm",
          hint: "Def: 3 ppm / rolling avg N/A",
          value: tvoc,
          name: "shortTermLimit.tvoc",
          error: errors?.tvoc,
        },
      ]}
      pmFields={[
        {
          label: "PM2.5",
          unit: "µg/m³",
          hint: "Def: 100 µg/m³ / 1-h rolling avg",
          value: pm25,
          name: "shortTermLimit.pm25",
          error: errors?.pm25,
        },
        {
          label: "PM10",
          unit: "µg/m³",
          hint: "Def: 100 µg/m³ / 8-h rolling avg",
          value: pm10,
          name: "shortTermLimit.pm10",
          error: errors?.pm10,
        },
      ]}
    />
  );
};

export default ShortTermLimit;
